
import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MtxColorpickerModule } from '@ng-matero/extensions/colorpicker';

@Component({
    selector: 'app-color-picker',
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatIconModule, MtxColorpickerModule],
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ColorPickerComponent),
            multi: true,
        },
    ]
})
export class ColorPickerComponent implements ControlValueAccessor, OnInit {
    @Input() label: string = 'Color picker';
    @Input() placeholder: string = '';
    @Input() appearance: 'fill' | 'outline' = 'outline';
    @Input() fullWidth: boolean = true;
    @Input() id?: string;

    public value: string = '';
    public disabled: boolean = false;
    private generatedId: string = '';
    private onChange: (value: string) => void = () => {};
    private onTouched: () => void = () => {};

    get inputId(): string {
        return this.generatedId;
    }

    get pickerId(): string {
        return `${this.generatedId}-picker`;
    }

    ngOnInit(): void {
        this.generatedId = this.id || `color-picker-${Math.random().toString(36).substr(2, 9)}`;
    }

    writeValue(value: string): void {
        this.value = value || '';
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onModelChange(value: string): void {
        this.value = value;
        this.onChange(value);
        this.onTouched();
    }
}
